import { BackendModule } from './../../../../modules/backend.module';

import { Injectable } from '@angular/core';
import { LocationsService } from './../../../../services/locations';
import { SessionService } from './../../../../services/session';

import { Plan } from './../../../../interfaces/plan';
import { HomePageButton } from '../../../../interfaces/home-page-button';
import {AuthService} from '../../../../services/auth';

@Injectable()
export class MembershipService {
  finalPrice: number = null;
  membershipPrice: number = null;
  displayText = '';
  planName = '';

  beautyFinalPrice: number = null;
  beautyMembershipPrice: number = null;
  beautyDisplayText = '';
  beautyPlanName = '';
  beautyCouponName = '';
  cancelClassInfoBeauty = '';
  reservationInfoBeauty = '';
  beautyExtras: number;

  hoursToCancelClass: number = null;
  messageToBasicUsers = '';
  goToMembership = false;
  cancelClassInfo = '';
  reservationInfo = '';
  couponName = '';
  paymentsUrl = '';
  processor = '';
  referralCode = '';
  referralInfo = '';
  referralTerms = [null, null];
  referralDiscount = null;
  city = '';
  cities: any;
  plans: Plan[];
  beautyPlans: Plan[];
  extras: string | number;
  option_to_buy_extra: string;
  cannot_cancel_extra: string;
  beautyCannotCancelExtra: string;
  beautyOptionToBuyExtra: string;
  delete_my_data_info: string;
  user_pause_info: string;
  public user_can_pause = false;

  homePageButtons: HomePageButton[] = [
    {
      name: 'clases',
      type: 'activities',
      image: 'cardio.jpg',
      activities: [1, 2, 3, 4, 5, 6, 7, 8, 9, 11, 12, 15, 16],
    },
    {
      name: 'gym',
      type: 'activities',
      image: 'strength.jpg',
      activities: [10],
    },
    {
      name: 'wellness',
      type: 'activities',
      image: 'zen.jpg',
      activities: [13, 14],
    },
    {
      "name": "favorites",
      "type": "favorites",
      "image": "intensity.jpg",
      "gyms": [
      ]
    }
  ];

  constructor(
    public locationsService: LocationsService,
    public sessionService: SessionService,
    public authService: AuthService,
    public backendModule: BackendModule
  ) {}

  changeCities(stateId) {
    this.cities = this.locationsService.getCitiesByStateId(stateId);
  }

  getPrice() {
    return new Promise((resolve, reject) => {
      this.backendModule
        .getAPI(`subscriptions/info?user_id=${this.sessionService.user.id}`)
        .subscribe(
          (result: any) => {
            console.log('[User Info] ', result);
            this.plans = result.user.plans;
            this.beautyPlans = result.user.beauty_plans;
            this.membershipPrice = result.user.price;
            this.finalPrice = result.user.price;
            this.displayText = result.user.info;
            this.messageToBasicUsers = result.user.upgrade_plan_info;
            this.cancelClassInfo = result.user.cancel_class_info;
            this.reservationInfo = result.user.reservation_info;
            this.cancelClassInfoBeauty = result.user.cancel_class_info_beauty;
            this.reservationInfoBeauty = result.user.reservation_info_beauty;
            this.hoursToCancelClass = result.user.hours;
            this.referralCode = result.user.referral_coupon;
            this.referralInfo = result.user.referral_info;
            this.referralDiscount = result.user.referral_discount;
            this.sessionService.nextPayment = result.user.next_payment_info;
            this.sessionService.nextPaymentBeauty = result.user.next_payment_info_beauty;
            this.sessionService.billingHTML = result.user.billing_info_html;
            this.sessionService.requestInvoiceURL =
              `${this.backendModule.backendURL}/${result.user.request_invoice_url}`;
            this.paymentsUrl = result.user.payments_url;
            this.processor = result.user.processor;
            this.extras = result.user.extras;
            this.beautyExtras = result.user.beauty_extras;

            this.option_to_buy_extra = result.user.option_to_buy_extra;
            this.beautyOptionToBuyExtra = result.user.beauty_option_to_buy_extra;

            this.cannot_cancel_extra = result.user.cannot_cancel_extra;
            this.beautyCannotCancelExtra = result.user.beauty_cannot_cancel_extra;

            this.delete_my_data_info = result.user.delete_my_data_info;
            this.user_pause_info = result.user.user_pause_info;
            this.user_can_pause = result.user.user_can_pause;
            this.homePageButtons = result.user.home_page_buttons;
            this.processor = result.user.processor;

            resolve(result);
          },
          (error) => {
            console.log('membershipService.getPrice().error: ', error);
            reject(error);
          }
        );
    });
  }

  selectBeautyPlan(planIndex: number) {
    this.beautyMembershipPrice = this.beautyPlans[planIndex].price;
    this.beautyFinalPrice = this.beautyPlans[planIndex].price;
    this.beautyDisplayText = this.beautyPlans[planIndex].info;
    this.beautyPlanName = this.beautyPlans[planIndex].plan;
  }

  selectPlan(planIndex) {
    this.membershipPrice = this.plans[planIndex].price;
    this.finalPrice = this.plans[planIndex].price;
    this.displayText = this.plans[planIndex].info;
    this.planName = this.plans[planIndex].plan;
  }


  cancelBeautyMembership() {
    this.authService.trackEvent('beautySubscription', 'delete', this.sessionService.user.id);
    return this.backendModule.postAPI('subscriptions/cancel_subscription.json', {
      user_id: this.sessionService.user.id,
      product: 'beauty',
    });
  }

  cancelMembership() {
    this.authService.trackEvent('subscription', 'delete', this.sessionService.user.id);
    return this.backendModule.postAPI('subscriptions/cancel_subscription.json', {
      user_id: this.sessionService.user.id
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/tabs/profile/membership/membership.service.ts